// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1s0NJ","inputWrap":"CustomTip_inputWrap__cuFwW"};